import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { chartColors, reasonKeyToContent } from "./FeedbackReports.constants";
import { headerConfigByFilter } from "./FeedbackReportsHead";
import FeedbackReportsTableContent from "./FeedbackReportsTableContent";
export const getElements = (series, seriesName) => {
  var _series$find$elements, _series$find;

  return (_series$find$elements = (_series$find = series.find(item => item.name === seriesName)) === null || _series$find === void 0 ? void 0 : _series$find.elements) !== null && _series$find$elements !== void 0 ? _series$find$elements : [];
};
export const calculateTotalCount = elements => elements.reduce((total, current) => current.count + total, 0);
export const getHeaderConfig = (reportBy, source) => headerConfigByFilter[reportBy] || headerConfigByFilter[source];
export const getColumns = (series, reportBy, reasonCategory) => getHeaderConfig(reportBy, reasonCategory).map(reasonKey => {
  const elements = getElements(series, reasonKey);
  const value = calculateTotalCount(elements);
  return {
    value,
    key: value,
    content: /*#__PURE__*/React.createElement(FeedbackReportsTableContent, {
      feedbackCount: value,
      reportBy: reportBy,
      reasonKey: reasonKey
    })
  };
});
export const getReportColumnsForSeries = (series, reportBy, source) => {
  const columns = getColumns(series, reportBy, source);
  const total = columns.reduce((newTotal, cell) => newTotal + cell.value, 0);
  return [...columns, {
    key: total,
    content: /*#__PURE__*/React.createElement(FeedbackReportsTableContent, {
      feedbackCount: total,
      reportBy: reportBy
    })
  }];
};
export const getFeedbackReportTableData = (reportApps, reportBy, source) => reportApps.map(app => ({
  appKey: app.addonKey,
  appName: app.name,
  columns: getReportColumnsForSeries(app.series, reportBy, source)
}));
export const getLines = headerConfig => headerConfig.map((reasonKey, index) => ({
  color: chartColors[index],
  dataKey: reasonKey,
  legend: reasonKeyToContent[reasonKey].name
}));

const getFeedbackCountOfReasonByIndex = (totalSeries, reasonKey, index) => {
  const elements = getElements(totalSeries, reasonKey);
  return elements[index] ? elements[index].count : 0;
};

export const getChartData = (totalSeries, headerConfig) => totalSeries[0].elements.map((element, index) => _objectSpread(_objectSpread({}, headerConfig.reduce((prev, reasonKey) => _objectSpread(_objectSpread({}, prev), {}, {
  [reasonKey]: getFeedbackCountOfReasonByIndex(totalSeries, reasonKey, index)
}), {})), {}, {
  xLabel: element.date
}));

const getValueFromPayload = (item, key) => {
  const value = item.payload[key];
  return typeof value === 'number' ? value : 0;
};

export const getChartTooltipPairs = payload => {
  const tooltips = payload.map(item => ({
    color: item.color,
    label: item.name,
    value: getValueFromPayload(item, item.dataKey)
  }));
  const totalFeedback = tooltips.reduce((total, tooltip) => total += tooltip.value, 0);
  return [...tooltips, {
    label: 'All feedback',
    value: totalFeedback
  }];
};